import { isProd, isQa, isDev } from 'config'

export const trackIntercomEvent = (key: string, data?: any) => {
  const theWindow = window as any
  const intercom: any = theWindow?.Intercom ?? theWindow?.intercom
  if (!intercom && !isDev) return console.log('intercom not found')
  if (isQa || isProd) intercom('trackEvent', key, data)
}
